import ApiClient from "~/admin/services/ApiClient";
import queryString from "query-string";

export default class BillsApi {
  static paginate = (page = null) => {
    let params = {};

    params.page = page;

    return ApiClient.get(`bills/paginate?${queryString.stringify(params)}`);
  };
}
